<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/twxzYa/tc-custom/9781504084000.jpg?1705766095282" alt="This image is the cover for the book Sea Leopard, The Kenneth Aubrey & Patrick Hyde Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sea Leopard, The Kenneth Aubrey & Patrick Hyde Series
      </h1>
      <p class="bookDescription body article font2">
        <b><i>New York Times</i>–Bestselling Author: A captured submarine must be retrieved from the Russians before they can decode its cutting-edge technology</b> . . .<br/>  <br/> The Royal Navy is testing Sea Leopard, an anti-sonar device that can make its subs virtually undetectable. But before the work can be completed, their nuclear submarine <i>Proteus</i> is targeted and trapped by the Soviet Union—whose military is determined to figure out, and steal, this new technology.<br/>  <br/> Spymaster Kenneth Aubrey sends SIS agent Patrick Hyde to locate the device’s inventor before the KGB gets to him first. In the meantime, a US Navy officer is on his way to Russia in hopes of fixing Sea Leopard and getting <i>Proteus</i> out of drydock before it’s too late . . .<br/>  <br/><b>Praise for Craig Thomas’s thrillers</b><br/>  <br/> “Will have you sweating bullets. Thomas misses no tricks, and tension is sustained from first page to last.” —<i>The New York Times Book Review</i><br/>  <br/> “High-octane.” —<i>Daily Express</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Craig Thomas
      </h2>
      
      <p class="authorDescription body article">Craig Thomas was a Welsh author of thrillers, most notably the Mitchell Gant novels and the Kenneth Aubrey &amp; Patrick Hyde series. His best-known novel, <I>Firefox</I>, brought him to global prominence and was adapted into film, directed by and starring Clint Eastwood. One of the pioneering techno-thriller writers, his work is often compared to Tom Clancy. Thomas passed away in 2011 at the age of sixty-nine.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?abc32fbc